// Phase 4 · AI Operating Layer — frontend API helpers.
// Additive. No modification to any locked lib.
import axios from "axios";
import { API } from "@/contexts/AuthContext";

const BASE = `${API}/ai/actions`;

export async function fetchCatalogue() {
  const { data } = await axios.get(`${BASE}/catalogue`);
  return data;
}

export async function proposeAction(assistant_key, action_id, payload) {
  const { data } = await axios.post(`${BASE}/propose`, {
    assistant_key, action_id, payload,
  });
  return data;
}

export async function confirmAction(action_row_id, confirmation_token, expectedWorkspace) {
  const { data } = await axios.post(`${BASE}/confirm`, {
    action_row_id, confirmation_token,
  }, { headers: expectedWorkspace ? { "X-Zynthoro-Expected-Workspace": expectedWorkspace } : {} });
  return data;
}

export async function cancelAction(action_row_id, expectedWorkspace) {
  const { data } = await axios.post(`${BASE}/cancel`, { action_row_id }, {
    headers: expectedWorkspace ? { "X-Zynthoro-Expected-Workspace": expectedWorkspace } : {},
  });
  return data;
}

export async function listActions(limit = 50) {
  const { data } = await axios.get(`${BASE}?limit=${limit}`);
  return data?.actions || [];
}


// Read-only recovery: this endpoint never confirms or re-executes an action.
export async function getActionStatus(action_row_id, expectedWorkspace) {
  const { data } = await axios.get(`${BASE}/${encodeURIComponent(action_row_id)}`, {
    headers: expectedWorkspace ? { "X-Zynthoro-Expected-Workspace": expectedWorkspace } : {},
  });
  return data;
}
